<template lang="pug">
  .container-settle.container-padding
    c-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/settle") 结算账户管理
          el-breadcrumb-item 富力钱包
          el-breadcrumb-item 代扣协议
    c-box
      iframe.agreement(:src="agreementUrl")
</template>

<script>
export default {
  data() {
    return {
      agreementUrl: "",
      verify_locked: false,
      countdown: -1
    };
  },
  computed: {},
  methods: {
    getAgreement() {
      this.$store
        .dispatch("YUNST_BALANCE_CONTRACT", this.$route.params.settle_account)
        .then(res => {
          console.log(res);
          this.agreementUrl = res.page_url;
        });
    },
    getWalletInfo() {
      this.$store
        .dispatch("GET_WALLET_CHANNEL_INFO", this.$route.params.settle_account)
        .then(res => {
          if (res.is_sign_contact === 2) {
            this.$router.push(
              `/wallet/reg-wallet-4/${this.$route.params.settle_account}/${this.$route.params.settle_id}`
            );
            clearInterval(this.timer);
          }
        });
    }
  },
  mounted() {
    this.getAgreement();
    this.timer = setInterval(() => {
      this.getWalletInfo();
    }, 2 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
<style lang="less" scoped>
.agreement {
  width: 100%;
  min-height: 700px;
}
</style>
